<template>
	<div class="vx-row">
		<div class="vx-col w-full">
			
			<div class="mb-6">
				<strong class="block mb-4">Nama Lengkap Sesuai KTP</strong>
				<vs-input
					class="w-full rounded-lg"
					v-validate="'required'"
					name="name"
					:danger="errors.has('name')"
					:value="name"
					disabled
				/>
				<span class="text-danger text-sm" v-show="errors.has('name')">
					<strong>{{ errors.first('name') }}</strong>
				</span>
			</div>
			<div class="mb-6">
				<strong class="block mb-4">Jenis Kelamin</strong>
				<v-select
					class="w-full"
					:options="jkOptions"
					v-model="jk"
				/>
			</div>
			<div class="mb-6">
				<strong class="block mb-4">NIK</strong>
				<vs-input
					class="w-full rounded-lg"
					v-validate="'required'"
					name="nik"
					:danger="errors.has('nik')"
					v-model="nik"
				/>
				<span class="text-danger text-sm" v-show="errors.has('nik')">
					<strong>{{ errors.first('nik') }}</strong>
				</span>
			</div>
			<div class="mb-6">
				<strong class="block mb-4">Tempat Lahir</strong>
				<vs-input
					class="w-full rounded-lg"
					v-validate="'required'"
					name="tempat_lahir"
					:danger="errors.has('tempat_lahir')"
					v-model="tempat_lahir"
				/>
				<span class="text-danger text-sm" v-show="errors.has('tempat_lahir')">
					<strong>{{ errors.first('tempat_lahir') }}</strong>
				</span>
			</div>
			<div class="mb-6">
				<strong class="block mb-4">Tanggal Lahir</strong>
				<vs-input
					type="date"
					class="w-full rounded-lg"
					v-validate="'required'"
					name="tanggal_lahir"
					:danger="errors.has('tanggal_lahir')"
					v-model="tanggal_lahir"
				/>
				<span class="text-danger text-sm" v-show="errors.has('tanggal_lahir')">
					<strong>{{ errors.first('tanggal_lahir') }}</strong>
				</span>
			</div>
			<div class="mb-6">
				<strong class="block mb-4">Pekerjaan</strong>
				<vs-input
					class="w-full rounded-lg"
					v-model="pekerjaan"
					name="pekerjaan"
					v-validate="'required'"
					:danger="errors.has('pekerjaan')"
				/>
				<span class="text-danger text-sm" v-show="errors.has('pekerjaan')">
					<strong>{{ errors.first('pekerjaan') }}</strong>
				</span>
			</div>
			<div class="mb-6">
				<strong class="block mb-4">No. Handphone</strong>
				<vs-input
					type="number"
					class="w-full rounded-lg"
					v-model="no_telp"
					name="no_telp"
					v-validate="'required'"
					:danger="errors.has('no_telp')"
				/>
				<span class="text-danger text-sm" v-show="errors.has('no_telp')">
					<strong>{{ errors.first('no_telp') }}</strong>
				</span>
			</div>
			<div class="mb-6">
				<strong class="block mb-4">Alamat</strong>
				<vs-textarea
					class="w-full rounded-lg"
					v-model="alamat"
					name="alamat"
					v-validate="'required'"
					:danger="errors.has('alamat')"
				/>
				<span class="text-danger text-sm" v-show="errors.has('alamat')">
					<strong>{{ errors.first('alamat') }}</strong>
				</span>
			</div>
			<div class="mb-12">
				<strong class="block mb-2">KTP Pengajuan Penerima Manfaat</strong>
				<input type="file" ref="ktp" class="hidden" @change="setFileKTP" />
				<div class="w-full flex items-center cursor-pointer rounded-l-md" @click="$refs['ktp'].click()" style="border: 1px solid #ccc;overflow: hidden">
					<vs-button icon-pack="feather" icon="icon-upload" class="rounded-l-md rounded-r-none"></vs-button>
					<span class="pl-4">{{ file_ktp_name }}</span>
				</div>
			</div>
			<div class="vx-row justify-center md:justify-end">
				<div class="vx-col w-full md:w-1/2">
					<vs-button class="w-full" @click.prevent="submit">
						Selanjutnya
					</vs-button>
				</div>
			</div>

		</div>
	</div>
</template>
<script>
	import { Validator } from 'vee-validate'

	const dict = {
		  custom: {
		    name: {
		      required: 'Harap masukan nama lengkap'
		    },
			nik: {
				required: 'Harap masukan NIK'
			},
			tempat_lahir: {
				required: 'Harap masukan tempat lahir'
			},
			tanggal_lahir: {
				required: 'Harap masukan tanggal lahir'
			},
			alamat: {
				required: 'Harap masukan alamat'
			},
		    pekerjaan: {
		    	required: 'Harap masukan pekerjaan anda'
		    },
		    no_telp: {
		    	required: 'Harap masukan nomer telepon anda'
		    }
		  }
	};

	Validator.localize('en', dict);

	export default {
		computed: {
			profile() {
				return this.$store.getters['auth/profile'];
			}
		},
		components: {
			vSelect: () => import('vue-select')
		},
		methods: {
			submit() {
				if(this.file_ktp === null ){
					 this.$vs.notify({
					 	title: 'Harap pilih foto ktp anda',
					 	text: '',
					 	color: 'warning',
					 	position: 'top-right'
					 });

					 return false;
				}

				this.$validator.validateAll().then(res => {
					if(res) {
						// save 
						this.$emit('submit', {
							name: this.name,
							pekerjaan: this.pekerjaan,
							no_telp: this.no_telp,
							nik: this.nik,
							jk: this.jk,
							alamat: this.alamat,
							tempat_lahir: this.tempat_lahir,
							tanggal_lahir: this.tanggal_lahir
						});
					}
				});
			},
			setFileKTP() {
				const file = this.$refs['ktp'].files[0];
				this.file_ktp = file;
				this.file_ktp_name = file.name;
				let arrFileName = file.name.split('.'),
				ext = arrFileName[arrFileName.length - 1].toLowerCase();

				if (!['pdf', 'docx', 'doc', 'jpg', 'png', 'jpeg', 'gif'].includes(ext)) {
					this.file_ktp = null;
					this.file_ktp_name = null;

					this.$vs.notify({
					  title: 'File tidak diperbolehkan',
					  text: 'Harap upload dokumen atau gambar',
					  color: 'danger',
					  position: 'top-right'
					});

					return false;
				}

				this.$emit('setFileKTP', this.file_ktp);
			}
		},
		data: () => ({
			alamat: null,
			jk: { id: 1, label: 'Laki-laki' },
			jkOptions: [
				{
					id: 1,
					label: 'Laki-laki'
				},
				{
					id: 2,
					label: 'Perempuan'
				}
			],
			nik: null,
			tempat_lahir: null,
			tanggal_lahir: null,
			file_ktp_name: null,
			file_ktp: null,
			name: null,
			no_telp: null,
			pekerjaan: null,
		}),
		created() {
			if(this.profile) {
				this.name = this.profile.name;
				this.no_telp = this.profile.no_telp;
			}
		}
	}
</script>